import clsx from 'clsx'

export function GreyBorderBottom({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 378 11"
      fill="none"
      className={clsx('h-[10px] w-full', className)}
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M-0.000183105 0.246094V10.2461H378V6.95662L-0.000183105 0.246094Z"
        fill="#363636"
      />
    </svg>
  )
}
